
import Vue from "vue";
import { mapActions, mapGetters } from "vuex";
import { GET_USER_DETAILS } from "@/store/modules/auth/constants";
import { get_job_by_id } from "@/store/apis/common";
import {
  PERSON_INTERVIEW_INVITES,
  INIT_AI_INTERVIEW_INVITES
} from "@/store/modules/recruiter_ai_interviews/constants";

export default Vue.extend({
  name: "CandidateFinalInterviewListing",
  data() {
    return {
      jobTitleById: {} as Record<string, string>
    };
  },
  computed: {
    ...mapGetters("auth", { user: GET_USER_DETAILS }),
    ...mapGetters("recruiter_ai_interviews", {
      personInvites: PERSON_INTERVIEW_INVITES
    }),
    candidateInvites(this: any): any[] {
      const candidateId = Number(this.user?.id || 0);
      if (!candidateId) return [];
      return (this.personInvites || []).filter(
        (invite: any) => Number(invite?.candidate_id || 0) === candidateId
      );
    }
  },
  async created(this: any) {
    await this.initInvites();
    await this.hydrateJobTitles();
  },
  watch: {
    candidateInvites: {
      deep: true,
      async handler(this: any) {
        await this.hydrateJobTitles();
      }
    }
  },
  methods: {
    ...mapActions("recruiter_ai_interviews", { initInvites: INIT_AI_INTERVIEW_INVITES }),
    openDetails(this: any, inviteId: string) {
      this.$router.push({ name: "candidate-final-interview-details", params: { inviteId } });
    },
    readableRole(this: any, invite: any): string {
      const jobTitle = String(invite?.job_title || "").trim();
      if (jobTitle && !/^job\s*#\s*\d+$/i.test(jobTitle)) return jobTitle;
      const jobRole = String(invite?.job_role || "").trim();
      if (jobRole && !/^job\s*#\s*\d+$/i.test(jobRole)) return jobRole;
      const jobId = String(invite?.job_id || "").trim();
      const resolved = String(this.jobTitleById[jobId] || "").trim();
      if (resolved) return resolved;
      return "-";
    },
    async hydrateJobTitles(this: any) {
      const invites = Array.isArray(this.candidateInvites) ? this.candidateInvites : [];
      for (const invite of invites) {
        const jobId = Number(invite?.job_id || 0);
        if (!jobId) continue;
        const key = String(jobId);
        if (this.jobTitleById[key]) continue;
        try {
          const resp = await get_job_by_id(jobId);
          const payload = resp?.data?.data || resp?.data || {};
          const title = String(payload?.job_title || payload?.title || "").trim();
          if (title && !/^job\s*#\s*\d+$/i.test(title)) {
            this.$set(this.jobTitleById, key, title);
          } else {
            this.$set(this.jobTitleById, key, "");
          }
        } catch (_e) {
          this.$set(this.jobTitleById, key, "");
        }
      }
    },
    formatDate(this: any, iso: string): string {
      const d = new Date(iso || "");
      if (isNaN(d.getTime())) return "Not scheduled";
      return d.toLocaleString();
    },
    durationLabel(this: any, invite: any): string {
      const duration = Number(invite?.duration_minutes || 0);
      return duration > 0 ? `${duration} min` : "30 min";
    }
  }
});
